// Maak een store met Pinia met Option API method
import { defineStore } from "pinia";

import axios from "axios";
// URL
const baseUrl = `${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/data/menus`;

export const useMenusStore = defineStore("menus", {
  state: () => ({
    menus: [],
    menu: null,
    loading: false,
    error: null
  }),
  actions: {
    async fetchMenus() {
      this.loading = true;
      try {
        const response = await axios.get(baseUrl);
        this.menus = response.data;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    async fetchMenuById(id) {
      this.loading = true;
      try {
        const response = await axios.get(`${baseUrl}/${id}`);
        this.menu = response.data;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    async createMenu(newMenu) {
      this.loading = true;
      try {
        const response = await axios.post(baseUrl, newMenu);
        this.menus.push(response.data);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    }, 

    async updateMenu(id, updatedMenu) {
      this.loading = true;
      try {
        const response = await axios.put(`${baseUrl}/${id}`, updatedMenu);
        const index = this.menus.findIndex((menu) => menu._id === id);
        if (index !== -1) {
          this.menus[index] = response.data;
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    async deleteMenu(id) {
      this.loading = true;
      try {
        await axios.delete(`${baseUrl}/${id}`);
        this.menus = this.menus.filter((menu) => menu._id !== id);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
});
